module.exports = __webpack_public_path__ + "img/img20.c3116b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/02/img20.png
// module id = 197
// module chunks = 0